module.exports = __webpack_public_path__ + "static/assets/569ae35224739f84b552ac4b19a881fd.svg";